import { useEffect, useState } from 'react';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import config from '@/config';
import FixedCharInput from '@/shared-components/inputs/components/FixedCharInput';

import './BoardBodyPicture.css';

export default function InlinePostImage({
  groupId, 
  image,
  onRemove,
  onCaptionChange,
  previewMode = false,
}) {
  const [isEditing, setIsEditing] = useState(false);

  const [caption, setCaption] = useState(image.picture_description || '');

  useEffect(() => {
    setCaption(image.picture_description || '');
  }, [image.picture_description]);

  const previewCaption = image.picture_description?.trim() || '';

  const handleCaptionChange = (e) => {
    const newCaption = e.target.value;
    setCaption(newCaption);
  };

  const saveCaption = () => {
    onCaptionChange(groupId, image.pictureId, caption);
    setIsEditing(false);
  };

  const imageUrl = `${config.app.imageServiceDomain}/${image.image_id}/w=2000`;

  return (
    <div className="post-image-with-caption">
      <div className="post-image-inline-container">
        {/* remove button only in edit */}
        {!previewMode && (
          <DeleteIcon
            className="post-image-inline-remove-button"
            onClick={onRemove}
          />
        )}
        <div className="image-wrapper">
          <img
            src={imageUrl}
            srcSet={`${config.app.imageServiceDomain}/${image.image_id}/w=200 200w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=400 400w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=600 600w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=800 800w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1000 1000w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1200 1200w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1400 1400w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1600 1600w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=1800 1800w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=2000 2000w,
                   ${config.app.imageServiceDomain}/${image.image_id}/w=2200 2200w`
            }
            alt="Uploaded post"
            className={"post-image-inline"}
          />
        </div>
      </div>

      {previewMode ? (
        previewCaption ? (
          <p className="post-image-inline-caption-preview">
            {previewCaption}
          </p>
        ) : null
      ) : (
        // in edit toggle between “Add description” and the editor
        !isEditing ? (
          <p
            className="post-image-inline-caption-add"
            contentEditable={false}
            onClick={() => {
              setIsEditing(true);
            }}
          >
            {caption || 'Add description'}
          </p>
        ) : (
          <div className="post-image-inline-caption-editor" contentEditable={false}>
            <DeleteIcon
              className="post-image-inline-caption-header-remove"
              onClick={saveCaption}
            />
            <FixedCharInput
              element={`post_picture_description_${image.image_id}`}
              label="Description"
              maxChar={200}
              value={caption}
              onChange={handleCaptionChange}
              onBlur={saveCaption}
            />
          </div>
        )
      )}
    </div>
  );
}
